import { api } from '@/utils/api'

export interface CreateWatchlistRequest {
  name: string
  description?: string
  account_uuids: string[]
}

export interface CreateWatchlistResponse {
  success: boolean
  message: string
  watchlist_id: string
  redirect_url: string
}

export interface WatchlistSummary {
  id: string
  name: string
  description: string
  created_at: string
  last_updated: string
  total_accounts: number
  username: string
}

export interface ListWatchlistsResponse {
  success: boolean
  total_watchlists: number
  watchlists: WatchlistSummary[]
}

export interface WatchlistData {
  id: string
  name: string
  description: string
  created_at: string
  last_updated: string
  total_accounts: number
  accounts: any[]
  aggregate_metrics: any
  performance_insights: any
  strategic_insights: any
  // Additional backend fields
  watchlist_id?: string
  user_id?: string
  username?: string
}

class WatchlistService {
  private baseUrl = '/v0_1/instagram'

  async createWatchlist(request: CreateWatchlistRequest): Promise<CreateWatchlistResponse> {
    return api.post(`${this.baseUrl}/watchlist`, request)
  }

  async getWatchlist(watchlistId: string): Promise<WatchlistData> {
    return api.get(`${this.baseUrl}/watchlist/${watchlistId}`)
  }

  async getUserWatchlists(): Promise<ListWatchlistsResponse> {
    return api.get(`${this.baseUrl}/watchlists`)
  }

  async deleteWatchlist(watchlistId: string): Promise<{ success: boolean; message: string }> {
    return api.delete(`${this.baseUrl}/watchlist/${watchlistId}`)
  }

  async renameWatchlist(watchlistId: string, newName: string): Promise<{ success: boolean; message: string }> {
    return api.put(`${this.baseUrl}/watchlist/${watchlistId}/rename`, { new_name: newName })
  }
}

export const watchlistService = new WatchlistService() 